export const getTimeAgo = (timestamp, t) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return t('just_now') || 'Zojuist';
    if (minutes < 60) return `${minutes} ${t('minutes_ago') || 'min geleden'}`;
    if (hours < 24) return `${hours} ${t('hours_ago') || 'uur geleden'}`;
    if (days === 1) return t('yesterday') || 'Gisteren';
    return `${days} ${t('days_ago') || 'dagen geleden'}`;
};

export const getInitials = (name) => {
    if (!name) return '';
    const parts = name.split(' ').filter(Boolean);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};